import RepairPartsManagement from "@/components/repairs/RepairPartsManagement";

const RepairPartsPage = () => {
  return (
    <div className="container mx-auto px-4 py-6 max-w-7xl">
      <RepairPartsManagement />
    </div>
  );
};

export default RepairPartsPage;
